export default __webpack_public_path__ + "static/media/azulo_logo.4cce135c.svg";